import { Link } from "react-router-dom";
import { GIVESENDGO_URL } from "../lib/api";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-neutral-200 bg-ink mt-32"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3 mb-4">
                        <span className="w-2 h-2 bg-blood"></span>
                        <span className="font-accent uppercase tracking-[0.25em] text-lg text-neutral-900">
                            State.of.Deception
                        </span>
                    </div>
                    <p className="font-mono text-lg text-neutral-500 leading-relaxed max-w-md">
                        A post-COVID political thriller about power, conscience,
                        and the cost of truth. Independently funded. Independently told.
                    </p>
                    <p className="font-mono text-base text-neutral-500 mt-6 uppercase tracking-widest">
                        Written by Jason Lewis
                    </p>
                    <p
                        data-testid="footer-address"
                        className="font-mono text-base text-neutral-500 mt-3"
                    >
                        50 S 6th St, Ste 1370, Minneapolis, MN 55402
                    </p>
                </div>

                <div>
                    <h4 className="font-accent uppercase tracking-[0.2em] text-base text-blood mb-4">
                        Navigate
                    </h4>
                    <ul className="space-y-3 font-mono text-lg">
                        <li>
                            <Link
                                to="/"
                                className="text-neutral-600 hover:text-neutral-900 transition-colors"
                                data-testid="footer-link-home"
                            >
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/about"
                                className="text-neutral-600 hover:text-neutral-900 transition-colors"
                                data-testid="footer-link-about"
                            >
                                The Film
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/get-involved"
                                className="text-neutral-600 hover:text-neutral-900 transition-colors"
                                data-testid="footer-link-get-involved"
                            >
                                Get Involved
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/contact"
                                className="text-neutral-600 hover:text-neutral-900 transition-colors"
                                data-testid="footer-link-contact"
                            >
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-accent uppercase tracking-[0.2em] text-base text-blood mb-4">
                        Take Action
                    </h4>
                    <ul className="space-y-3 font-mono text-lg">
                        <li>
                            <a
                                href={GIVESENDGO_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-neutral-600 hover:text-neutral-900 transition-colors"
                                data-testid="footer-link-donate"
                            >
                                Donate on GiveSendGo
                            </a>
                        </li>
                        <li>
                            <Link
                                to="/get-involved#casting"
                                className="text-neutral-600 hover:text-neutral-900 transition-colors"
                                data-testid="footer-link-casting"
                            >
                                Audition for a Role
                            </Link>
                        </li>
                        <li>
                            <a
                                href="mailto:Valkyrie@valkyriestrategies.com"
                                className="text-neutral-600 hover:text-neutral-900 transition-colors"
                                data-testid="footer-link-press"
                            >
                                Press &amp; Inquiries
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-neutral-200">
                <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="font-mono text-base text-neutral-500 uppercase tracking-widest">
                        © {new Date().getFullYear()} State of Deception, LLC. All rights reserved.
                    </p>
                    <p className="font-mono text-base text-neutral-500 uppercase tracking-widest">
                        An Independent Feature Film / SOD-2026
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
